var $7b7a9dc96338bc57$exports = {};
$7b7a9dc96338bc57$exports = {
    "info": `Informasjon`,
    "negative": `Feil`,
    "notice": `Advarsel`,
    "positive": `Vellykket`
};


export {$7b7a9dc96338bc57$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
